import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { setFilteredCategories, useOrderFormStore } from 'stores/orderForm/orderForm';

import { SearchInput } from 'components/SearchInput/SearchInput';

import { filterProductsInCategories } from './utils/searchFilters';

const showActiveInputBorder = 'p-px';

export const Search = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const { categories } = useOrderFormStore();

  const handleSearch = useCallback(
    (searchTerm: string) => {
      setSearchTerm(searchTerm);
      if (!categories) {
        return;
      }

      const filteredCategories = filterProductsInCategories(categories, searchTerm);
      setFilteredCategories(filteredCategories);
    },
    [categories],
  );

  return (
    <div className={showActiveInputBorder}>
      <SearchInput
        className="mb-6"
        placeholder={t('orderForms:form.sidebar.search')}
        filter={searchTerm}
        onFilterChange={handleSearch}
      />
    </div>
  );
};
